import { SmallClassCodeComboBoxModel } from '../small-class-code-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 小分類情報リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetSmallClassListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetSmallClassListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: SmallClassCodeComboBoxModel;
  private orderCode: string = null;
  private classCode: string = null;
  private largeClassCode: string = null;
  private middleClassCode: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSmallClassListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode,
        ClassCode: this.classCode,
        LargeClassCode: this.largeClassCode,
        MiddleClassCode: this.middleClassCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {SmallClassCodeComboBoxModel} model
   * @param {string} orderCode
   * @param {string} classCode
   * @param {string} largeClassCode
   * @param {string} middleClassCode
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetSmallClassListService
   */
  execute(model: SmallClassCodeComboBoxModel, orderCode: string, classCode: string,
      largeClassCode: string, middleClassCode: string, successFunc: Function = null) {
    this.model = model;
    this.orderCode = orderCode;
    this.classCode = classCode;
    this.largeClassCode = largeClassCode;
    this.middleClassCode = middleClassCode;
    this.successFunc = successFunc;
    this.send('KYMW02getSmallClassList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSmallClassListService
   */
  success(data: any) {
    this.model.updateSmallClassList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
